import axiosClient from './axiosClient';

export const getTournamentnament = (): Promise<any> => {
    const url = `${process.env.REACT_APP_PUBLIC_URL}/documents/api/quotes-document/tournaments`;
    return axiosClient.get(url);
};